var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHandCoins(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2940_17809)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1562 6.125C12.0019 6.125 12.6875 5.43944 12.6875 4.59375C12.6875 3.74806 12.0019 3.0625 11.1562 3.0625C10.3106 3.0625 9.625 3.74806 9.625 4.59375C9.625 5.43944 10.3106 6.125 11.1562 6.125Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.625 11.375H0.875C0.758968 11.375 0.647688 11.3289 0.565641 11.2469C0.483594 11.1648 0.4375 11.0535 0.4375 10.9375V8.75C0.4375 8.63397 0.483594 8.52269 0.565641 8.44064C0.647688 8.35859 0.758968 8.3125 0.875 8.3125H2.625",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.625 11.375H0.875C0.758968 11.375 0.647688 11.3289 0.565641 11.2469C0.483594 11.1648 0.4375 11.0535 0.4375 10.9375V8.75C0.4375 8.63397 0.483594 8.52269 0.565641 8.44064C0.647688 8.35859 0.758968 8.3125 0.875 8.3125H2.625",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.125 8.75H7.875L11.5391 7.90727C11.6738 7.87035 11.8152 7.865 11.9523 7.89163C12.0894 7.91825 12.2185 7.97614 12.3296 8.06079C12.4408 8.14544 12.5308 8.25457 12.5929 8.3797C12.655 8.50483 12.6873 8.64259 12.6875 8.78227C12.6876 8.95092 12.6406 9.11625 12.5519 9.2597C12.4633 9.40316 12.3364 9.51905 12.1855 9.59438L10.0625 10.5L6.5625 11.375H2.625V8.3125L3.99219 6.94532C4.11439 6.82354 4.2594 6.72705 4.41892 6.66136C4.57845 6.59567 4.74936 6.56208 4.92188 6.5625H7.65625C7.94633 6.5625 8.22453 6.67774 8.42965 6.88286C8.63477 7.08797 8.75 7.36617 8.75 7.65625C8.75 7.94633 8.63477 8.22453 8.42965 8.42965C8.22453 8.63477 7.94633 8.75 7.65625 8.75H6.125Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.62343 4.66354C9.32624 4.8041 8.9917 4.84527 8.6693 4.78098C8.34689 4.71669 8.05374 4.55034 7.83319 4.30654C7.61265 4.06274 7.47642 3.75443 7.44466 3.42722C7.41291 3.1 7.4873 2.77125 7.65685 2.48959C7.8264 2.20793 8.08209 1.98831 8.38612 1.86322C8.69014 1.73813 9.02636 1.71421 9.34503 1.795C9.6637 1.87578 9.94791 2.05699 10.1556 2.3118C10.3633 2.56662 10.4835 2.88153 10.4984 3.20994",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2940_17809"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandCoins);
export default __webpack_public_path__ + "static/media/HandCoins.418353989bac76325c7afc47941e2dd1.svg";
export { ForwardRef as ReactComponent };